import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class SystemChatMessage extends AbstractChatMessage {
  body: string = ''

  constructor(data: LX.SystemChatMessage) {
    super(data)
    this.body = data.body as string
  }

  static fromServer(data: LX.SystemChatMessage) {
    if (data.body instanceof Object) {
      return new SystemChatMessage({ ...data, body: data.body.comment })
    } else {
      return new SystemChatMessage(data)
    }
  }

  getShortMessage() {
    switch (this.type) {
      case MessageTypes.ROOM_CLOSED:
        return 'This room has been closed'
      default:
        return ''
    }
  }
}
